"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTooltip = exports.TooltipArrow = exports.getArrowPlacement = exports.placementArray = void 0;
var react_1 = __importDefault(require("react"));
var style_utils_1 = require("@nef/style-utils");
var styled_components_1 = __importStar(require("styled-components"));
var hooks_1 = require("@nef/hooks");
var Popover_1 = __importDefault(require("../Popover"));
var Portal_1 = __importDefault(require("../Portal"));
exports.placementArray = [
    "top",
    "top-start",
    "top-end",
    "right",
    "right-start",
    "right-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "left",
    "left-start",
    "left-end"
];
var getArrowPlacement = function (placement) {
    switch (placement) {
        case "top":
            return "bottom";
        case "top-start":
            return "bottom-start";
        case "top-end":
            return "bottom-end";
        case "right":
            return "left";
        case "right-start":
            return "left-start";
        case "right-end":
            return "left-end";
        case "bottom":
            return "top";
        case "bottom-start":
            return "top-start";
        case "bottom-end":
            return "top-end";
        case "left":
            return "right";
        case "left-start":
            return "right-start";
        case "left-end":
            return "right-end";
        default:
            return "bottom";
    }
};
exports.getArrowPlacement = getArrowPlacement;
var innerFunction = react_1.default.forwardRef(function (_a, ref) {
    var arrowPlacement = _a.arrowPlacement, props = __rest(_a, ["arrowPlacement"]);
    return react_1.default.createElement(Popover_1.default, __assign({ innerRef: ref }, props));
});
innerFunction.displayName = "innerFunction";
exports.TooltipArrow = styled_components_1.default.span(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  position: ", ";\n  z-index: 1060;\n  display: block;\n  opacity: 0;\n  left: 0;\n  top: 0;\n\n  ", ";\n\n  &::before {\n    position: absolute;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  @keyframes popIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n"], ["\n  position: ", ";\n  z-index: 1060;\n  display: block;\n  opacity: 0;\n  left: 0;\n  top: 0;\n\n  ",
    ";\n\n  &::before {\n    position: absolute;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid;\n  }\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n  @keyframes popIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n"])), function (props) { return (props.$fixed ? "fixed" : "absolute"); }, function (props) {
    return props.$isAnimated
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          -webkit-animation: popIn 166ms ease-in-out 83ms forwards;\n          animation: popIn 166ms ease-in-out 83ms forwards;\n        "], ["\n          -webkit-animation: popIn 166ms ease-in-out 83ms forwards;\n          animation: popIn 166ms ease-in-out 83ms forwards;\n        "]))) : styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          animation: popIn 0ms ease-in-out 83ms forwards;\n        "], ["\n          animation: popIn 0ms ease-in-out 83ms forwards;\n        "])));
}, function (props) {
    return props.$arrowPlacement.includes("top") && styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      width: 0.8rem;\n      height: 0.5rem;\n      ", ";\n      ", ";\n      ", ";\n      top: calc(", "px - 0.325rem);\n      transform: translateX(-50%);\n\n      ::before {\n        border-bottom-color: ", ";\n        border-width: 0 0.4rem 0.4rem 0.4rem;\n        top: 0;\n\n        ", ";\n      }\n    "], ["\n      width: 0.8rem;\n      height: 0.5rem;\n      ",
        ";\n      ",
        ";\n      ",
        ";\n      top: calc(", "px - 0.325rem);\n      transform: translateX(-50%);\n\n      ::before {\n        border-bottom-color: ", ";\n        border-width: 0 0.4rem 0.4rem 0.4rem;\n        top: 0;\n\n        ",
        ";\n      }\n    "])), props.$arrowPlacement.includes("start") && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          left: ", "px;\n        "], ["\n          left: ", "px;\n        "])), props.$arrowPlacementValues.left), props.$arrowPlacement.includes("end") && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          left: ", "px;\n        "], ["\n          left: ", "px;\n        "])), props.$arrowPlacementValues.left), !props.$arrowPlacement.includes("start") &&
        !props.$arrowPlacement.includes("end") && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          left: ", "px;\n        "], ["\n          left: ", "px;\n        "])), props.$arrowPlacementValues.left), props.$arrowPlacementValues.top, style_utils_1.colorSelector(props, "gray", 900), props.$color === "danger" && styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            border-bottom-color: ", ";\n          "], ["\n            border-bottom-color: ", ";\n          "])), style_utils_1.colorSelector(props, "gray", 0)));
}, function (props) {
    return props.$arrowPlacement.includes("bottom") && styled_components_1.css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      width: 0.8rem;\n      height: 0.4rem;\n      top: calc(", "px - 0.075rem);\n      ", ";\n      ", ";\n      ", ";\n      transform: translateX(-50%);\n\n      ::before {\n        border-top-color: ", ";\n        border-width: 0.4rem 0.4rem 0;\n        left: 0;\n\n        ", ";\n      }\n    "], ["\n      width: 0.8rem;\n      height: 0.4rem;\n      top: calc(", "px - 0.075rem);\n      ",
        ";\n      ",
        ";\n      ",
        ";\n      transform: translateX(-50%);\n\n      ::before {\n        border-top-color: ", ";\n        border-width: 0.4rem 0.4rem 0;\n        left: 0;\n\n        ",
        ";\n      }\n    "])), props.$arrowPlacementValues.top, props.$arrowPlacement.includes("start") && styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n          left: ", "px;\n        "], ["\n          left: ", "px;\n        "])), props.$arrowPlacementValues.left), props.$arrowPlacement.includes("end") && styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n          left: ", "px;\n        "], ["\n          left: ", "px;\n        "])), props.$arrowPlacementValues.left), !props.$arrowPlacement.includes("start") &&
        !props.$arrowPlacement.includes("end") && styled_components_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n          left: ", "px;\n        "], ["\n          left: ", "px;\n        "])), props.$arrowPlacementValues.left), style_utils_1.colorSelector(props, "gray", 900), props.$color === "danger" && styled_components_1.css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n            border-top-color: ", ";\n          "], ["\n            border-top-color: ", ";\n          "])), style_utils_1.colorSelector(props, "gray", 0)));
}, function (props) {
    return props.$arrowPlacement.includes("left") && styled_components_1.css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n      width: 0.4rem;\n      height: 0.8rem;\n      left: calc(", "px - 0.325rem);\n      ", ";\n      ", ";\n      ", ";\n      transform: translateY(-50%);\n\n      ::before {\n        border-right-color: ", ";\n        border-width: 0.4rem 0.4rem 0.4rem 0;\n        left: 0;\n\n        ", ";\n      }\n    "], ["\n      width: 0.4rem;\n      height: 0.8rem;\n      left: calc(", "px - 0.325rem);\n      ",
        ";\n      ",
        ";\n      ",
        ";\n      transform: translateY(-50%);\n\n      ::before {\n        border-right-color: ", ";\n        border-width: 0.4rem 0.4rem 0.4rem 0;\n        left: 0;\n\n        ",
        ";\n      }\n    "])), props.$arrowPlacementValues.left, props.$arrowPlacement.includes("start") && styled_components_1.css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n          top: ", "px;\n        "], ["\n          top: ", "px;\n        "])), props.$arrowPlacementValues.top), props.$arrowPlacement.includes("end") && styled_components_1.css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n          top: ", "px;\n        "], ["\n          top: ", "px;\n        "])), props.$arrowPlacementValues.top), !props.$arrowPlacement.includes("start") &&
        !props.$arrowPlacement.includes("end") && styled_components_1.css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n          top: ", "px;\n        "], ["\n          top: ", "px;\n        "])), props.$arrowPlacementValues.top), style_utils_1.colorSelector(props, "gray", 900), props.$color === "danger" && styled_components_1.css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n            border-right-color: ", ";\n          "], ["\n            border-right-color: ", ";\n          "])), style_utils_1.colorSelector(props, "gray", 0)));
}, function (props) {
    return props.$arrowPlacement.includes("right") && styled_components_1.css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n      width: 0.4rem;\n      height: 0.8rem;\n      left: calc(", "px - 0.075rem);\n      ", ";\n      ", ";\n      ", ";\n      transform: translateY(-50%);\n\n      ::before {\n        border-left-color: ", ";\n        border-width: 0.4rem 0 0.4rem 0.4rem;\n        right: 0;\n\n        ", ";\n      }\n    "], ["\n      width: 0.4rem;\n      height: 0.8rem;\n      left: calc(", "px - 0.075rem);\n      ",
        ";\n      ",
        ";\n      ",
        ";\n      transform: translateY(-50%);\n\n      ::before {\n        border-left-color: ", ";\n        border-width: 0.4rem 0 0.4rem 0.4rem;\n        right: 0;\n\n        ",
        ";\n      }\n    "])), props.$arrowPlacementValues.left, props.$arrowPlacement.includes("start") && styled_components_1.css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n          top: ", "px;\n        "], ["\n          top: ", "px;\n        "])), props.$arrowPlacementValues.top), props.$arrowPlacement.includes("end") && styled_components_1.css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n          top: ", "px;\n        "], ["\n          top: ", "px;\n        "])), props.$arrowPlacementValues.top), !props.$arrowPlacement.includes("start") &&
        !props.$arrowPlacement.includes("end") && styled_components_1.css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n          top: ", "px;\n        "], ["\n          top: ", "px;\n        "])), props.$arrowPlacementValues.top), style_utils_1.colorSelector(props, "gray", 900), props.$color === "danger" && styled_components_1.css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n            border-left-color: ", ";\n          "], ["\n            border-left-color: ", ";\n          "])), style_utils_1.colorSelector(props, "gray", 0)));
});
exports.StyledTooltip = styled_components_1.default(innerFunction)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  ", ";\n  margin: 0;\n  font-family: ", ";\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  line-break: auto;\n  overflow: visible !important;\n\n  & > .tooltip-wrapper {\n    ", ";\n    ", ";\n    ", ";\n    color: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    text-align: center;\n    font-size: 0.85714rem;\n\n    ", ";\n  }\n"], ["\n  ", ";\n  margin: 0;\n  font-family: ", ";\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  line-break: auto;\n  overflow: visible !important;\n\n  & > .tooltip-wrapper {\n    ", ";\n    ", ";\n    ", ";\n    color: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n    text-align: center;\n    font-size: 0.85714rem;\n\n    ",
    ";\n  }\n"])), style_utils_1.setPadding("y", 0), style_utils_1.getFont("sansSerif"), style_utils_1.setPadding("y", 2), style_utils_1.setPadding("x", 3), function (props) { return style_utils_1.setBoxShadow(style_utils_1.shadowSelector(props, 1)); }, style_utils_1.getColor("gray", 0), style_utils_1.getBorderRadius("md"), style_utils_1.getColor("gray", 900), function (props) {
    return props.color === "danger" && styled_components_1.css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n        background-color: ", ";\n        color: ", ";\n      "], ["\n        background-color: ", ";\n        color: ", ";\n      "])), style_utils_1.colorSelector(props, "gray", 0), style_utils_1.colorSelector(props, props.color, 500));
});
var setArrowPosition = function (element, tooltip, placement) {
    var _a = (element === null || element === void 0 ? void 0 : element.getBoundingClientRect()) || {
        height: 0,
        left: 0,
        top: 0,
        width: 0
    }, height = _a.height, left = _a.left, top = _a.top, width = _a.width;
    var _b = (tooltip === null || tooltip === void 0 ? void 0 : tooltip.getBoundingClientRect()) || {
        height: 0,
        left: 0,
        top: 0,
        width: 0
    }, tooltipHeight = _b.height, tooltipLeft = _b.left, tooltipTop = _b.top, tooltipWidth = _b.width;
    switch (placement) {
        case "top":
            return {
                left: left + width / 2,
                top: tooltipTop
            };
        case "bottom":
            return {
                left: left + width / 2,
                top: tooltipTop + tooltipHeight
            };
        case "top-start":
            return {
                left: left + width * 0.2,
                top: tooltipTop
            };
        case "bottom-start":
            return {
                left: left + width * 0.2,
                top: tooltipTop + tooltipHeight
            };
        case "top-end":
            return {
                left: left + width * 0.8,
                top: tooltipTop
            };
        case "bottom-end":
            return {
                left: left + width * 0.8,
                top: tooltipTop + tooltipHeight
            };
        case "left":
            return {
                left: tooltipLeft,
                top: top + height / 2
            };
        case "right":
            return {
                left: tooltipLeft + tooltipWidth,
                top: top + height / 2
            };
        case "left-start":
            return {
                left: tooltipLeft,
                top: top + height * 0.4
            };
        case "right-start":
            return {
                left: tooltipLeft + tooltipWidth,
                top: top + height * 0.4
            };
        case "left-end":
            return {
                left: tooltipLeft,
                top: top + height * 0.6
            };
        case "right-end":
            return {
                left: tooltipLeft + tooltipWidth,
                top: top + height * 0.6
            };
        default:
            return {
                left: 0,
                top: 0
            };
    }
};
var Tooltip = react_1.default.forwardRef(function (_a, ref) {
    var arrowClassName = _a.arrowClassName, children = _a.children, color = _a.color, fixed = _a.fixed, hideArrow = _a.hideArrow, isAnimated = _a.isAnimated, isOpen = _a.isOpen, propsOnKeyDown = _a.onKeyDown, placement = _a.placement, target = _a.target, toggle = _a.toggle, props = __rest(_a, ["arrowClassName", "children", "color", "fixed", "hideArrow", "isAnimated", "isOpen", "onKeyDown", "placement", "target", "toggle"]);
    var tooltipRef = react_1.default.useRef();
    var _b = __read(react_1.default.useState(placement), 2), statePlacement = _b[0], setStatePlacement = _b[1];
    var _c = __read(react_1.default.useState(exports.getArrowPlacement(placement)), 2), arrowPlacement = _c[0], setArrowPlacement = _c[1];
    var _d = __read(react_1.default.useState({
        left: 0,
        top: 0
    }), 2), vals = _d[0], setVals = _d[1];
    var combinedRef = hooks_1.useCombinedRefs(ref, tooltipRef);
    var handleKeyDown = function (e) {
        if (e.key === "Escape" || e.key === "Esc" || e.key === "Tab") {
            toggle === null || toggle === void 0 ? void 0 : toggle(e);
        }
        propsOnKeyDown === null || propsOnKeyDown === void 0 ? void 0 : propsOnKeyDown(e);
    };
    var onKeyDown = hooks_1.useKeyDown({
        ref: { current: document.getElementById(target) },
        onKeyDown: handleKeyDown
    }).onKeyDown;
    react_1.default.useEffect(function () {
        var element = document.getElementById(target);
        if (element) {
            element.addEventListener("focus", toggle);
            element.addEventListener("keydown", onKeyDown);
        }
        return function () {
            element === null || element === void 0 ? void 0 : element.removeEventListener("focus", toggle);
            element === null || element === void 0 ? void 0 : element.removeEventListener("keydown", onKeyDown);
        };
    }, [target]);
    react_1.default.useEffect(function () {
        setStatePlacement(placement);
        setArrowPlacement(exports.getArrowPlacement(placement));
    }, [placement, isOpen]);
    react_1.default.useEffect(function () {
        var element = document.getElementById(target);
        if (element) {
            setVals(setArrowPosition(element, tooltipRef.current, arrowPlacement));
        }
    }, [target, arrowPlacement, tooltipRef === null || tooltipRef === void 0 ? void 0 : tooltipRef.current, isOpen]);
    var onPlacementForceChange = function (newPlacement) {
        setStatePlacement(newPlacement);
        setArrowPlacement(exports.getArrowPlacement(newPlacement));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.StyledTooltip, __assign({}, props, { color: color, fixed: fixed, isAnimated: isAnimated, target: target, toggle: toggle, arrowPlacement: arrowPlacement, isOpen: isOpen, maxContent: true, onPlacementForceChange: onPlacementForceChange, oppositeOnOverflow: true, placement: statePlacement, tooltip: true, ref: combinedRef }),
            react_1.default.createElement("div", { className: "tooltip-wrapper" }, children)),
        react_1.default.createElement(Portal_1.default, null, !hideArrow && isOpen && (react_1.default.createElement(exports.TooltipArrow, { "$color": color, "$fixed": fixed, "$isAnimated": isAnimated, "$arrowPlacement": arrowPlacement, "$arrowPlacementValues": vals })))));
});
Tooltip.displayName = "Tooltip";
Tooltip.defaultProps = {
    delay: 0,
    fixed: false,
    isAnimated: true,
    placement: "top",
    trigger: "hover"
};
exports.default = Tooltip;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25;
//# sourceMappingURL=index.js.map